// Modules
import { useEffect, useState, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import type { RootState } from '../../types/store';
import AppActions from '../../actions/app-actions';
import AppConstants from '../../constants/app-constants';
import AppUtils from '../../utils/app-utils';
import AppWebsocket from '../../utils/app-websocket';

import UILobbyError from '../../components/ui-lobby-error';
import FullScreenPopup from '../../components/popup/fullscreen';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';

import LobbyWaiting from './lobby-waiting';
import LobbyStarting from './lobby-starting';
import LobbyQuestion from './lobby-question';
import LobbyDrink from './lobby-drink';
import LobbyAdvertise from './lobby-advertise';
import LobbySlot from './lobby-slot';
import LobbyDone from './lobby-done';


export default function Lobby() {
    const [sentCookie, setSentCookie] = useState(false);
    const lobby = useSelector((state: RootState) => state.page.lobby);
    const websocket = useSelector((state: RootState) => state.ui.websocketState);
    const translate = useSelector((state: RootState) => state.ui.language.lobby);
    const { code } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const oldLobbyState = useRef(-1);
    const oldLobbyCode = useRef(lobby.code);

    const handle = useFullScreenHandle();

    const wsConnectionRef = useRef<typeof AppWebsocket | null>(null);
    useEffect(() => {
        if (!wsConnectionRef.current) {
            wsConnectionRef.current = AppWebsocket;
            AppWebsocket.onConnect();


            // Default stuff
            /* dispatch(AppActions.LobbyState({
                 code: 1000,
                 state: AppConstants.STATE_DESYNC,
                 number_questions: 5,
                 playing: true,
                 nickname: 'Jacobs',
                 categories: [1, 4, 5],
                 admin: 1,
                 players: [
                     { nickname: 'Anton', icon: 2, online: 1 },
                     { nickname: 'Steve', icon: 1, online: 1 },
                     { nickname: 'Jacob', icon: 3, online: 1 },

                     { nickname: 'Anton2', online: 1 }, { nickname: 'Steve2', icon: 1, online: 0 }, { nickname: 'Jacob2', icon: 3, online: 1 },
                     { nickname: 'Anton3', online: 1 }, { nickname: 'Steve3', online: 1 }, { nickname: 'Jacob3', online: 1 },
                     { nickname: 'Anton4', online: 1 }, { nickname: 'Steve4', online: 0 }, { nickname: 'Jacob4', online: 1 },
                     { nickname: 'Anton5', online: 1 }, { nickname: 'Steve5', icon: 1, online: 0 }, { nickname: 'Jacob5', icon: 3, online: 1 },
                     { nickname: 'Anton6', icon: 2, online: 1 }, { nickname: 'Steve6', online: 0 }, { nickname: 'Jacob6', icon: 3, online: 1 },
                     { nickname: 'Anton7', icon: 2, online: 1 }, { nickname: 'Steve7', icon: 1, online: 0 }, { nickname: 'Jacob7', icon: 3, online: 1 },
                     { nickname: 'Anton8', icon: 2, online: 1 }, { nickname: 'Steve8', icon: 1, online: 0 }, { nickname: 'Jacob8', icon: 3, online: 1 },
                     { nickname: 'Anton9', icon: 2, online: 1 }, { nickname: 'Steve9', icon: 1, online: 0 }, { nickname: 'Jacob9', icon: 3, online: 1 },
                     { nickname: 'Anton10', icon: 2, online: 1 }, { nickname: 'Steve10', icon: 1, online: 0 }, { nickname: 'Jacob10', icon: 3, online: 1 },
                     { nickname: 'Anton11', icon: 2, online: 1 }, { nickname: 'Steve11', icon: 1, online: 0 }, { nickname: 'Jacob11', icon: 3, online: 1 },
                     { nickname: 'Anton12', icon: 2, online: 1 }, { nickname: 'Steve12', icon: 1, online: 0 }, { nickname: 'Jacob12', icon: 3, online: 1 },
                     { nickname: 'Anton13', icon: 2, online: 1 }, { nickname: 'Steve13', icon: 1, online: 0 }, { nickname: 'Jacob13', icon: 3, online: 1 },
                     { nickname: 'Anton14', icon: 2, online: 1 }, { nickname: 'Steve14', icon: 1, online: 0 }, { nickname: 'Jacob14', icon: 3, online: 1 },
                     { nickname: 'Anton15', icon: 2, online: 1 }, { nickname: 'Steve15', icon: 1, online: 0 }, { nickname: 'Jacob15', icon: 3, online: 1 },
                 ]
             }));*/

            //dispatch(AppActions.LobbyUpdate({
            //    state: AppConstants.STATE_LOBBY,
            //    timeleft: 5,
            // This is set from the question state

            /*
                question: 2,
                answer: 0,
                current_question: {
                    question: "Would you rather?",
                    category: AppConstants.CATEGORY_SPILL_BEANS,
                    options: [
                        { id: 1, value: "Ja" },
                        { id: 2, value: "Nej" },
                        { id: 3, value: "Nej" },
                        { id: 4, value: "Nej" },

                    ]
                },
            */

            // This is for the STATE_DRINK part
            /*drink: {
                question_extra: "This question has EXTRA INFO!",
                text: "",
                correct: ['antondator', 'Anton'],
                wrong: [
                     { nickname: 'Jacob', option: 3 },
                     { nickname: 'Jakob', option: 2 },
                     { nickname: 'Lisa', option: 2 },
                     { nickname: 'Sandra', option: 2 },
                     { nickname: 'Kajsa', option: 3 }
                ],
                timeout: [], //['Noobcob'],
                correct_option: "Nej",
                correct_option_id: 2
            },*/

            // This is for the done part
            /*done: {
                players: [
                    { nickname: "Anton", score: 10 },
                    { nickname: "Steve", score: 8 },
                    { nickname: "Jacob", score: 5 },
                ]
            }*/
            //}));
        }

        return () => {
            if (wsConnectionRef.current) {
                AppWebsocket.onDisconnect(true);
                wsConnectionRef.current = null;
            }

            if (!import.meta.env.VITE_DEBUG) {
                dispatch(AppActions.LobbyReset());
            }
        };
    }, []);

    useEffect(() => {
        if (websocket === AppConstants.STATE_WEBSOCKET_ONLINE) // && lobby.code === 0 && code != 0)
        {
            const cookie = AppUtils.getLoginCookie();
            if (cookie) {
                dispatch(AppActions.LoginTokenWebsocket({ token: cookie }));
            }

            checkCookie();
        }

    }, [websocket]);

    useEffect(() => {
        if (oldLobbyState.current !== -1 && lobby.state !== oldLobbyState.current) {
            AppUtils.vibrate(200);
        }

        if (lobby.state === AppConstants.STATE_QUESTION && oldLobbyState.current !== AppConstants.STATE_QUESTION) {
            if (!import.meta.env.DEV) {
                dispatch(AppActions.GameResetAnswer({}));
            }
        }
        oldLobbyState.current = lobby.state;
    }, [lobby.state]);

    useEffect(() => {
        if (lobby.code === 0 && oldLobbyCode.current !== 0) {
            navigate("/");
        }
        oldLobbyCode.current = lobby.code;
    }, [lobby.code]);

    async function onFullScreen() {
        try {
            await handle.enter();
        } catch (e) {
            AppUtils.log("Failed to enter fullscreen", e);
        }
    }

    function checkCookie() {
        let cookie = AppUtils.getCookie(code);
        if (cookie !== undefined) {
            setSentCookie(true);
            dispatch(AppActions.Cookie({ cookie: cookie, code: code }));
        } else {
            if (lobby.code === 0) {
                dispatch(AppActions.LobbyError(AppConstants.ERR_COOKIE_INVALID));
            }
        }
    }

    AppUtils.log("[Lobby]", lobby);

    if (websocket === AppConstants.STATE_WEBSOCKET_IDLE) {
        if (!import.meta.env.DEV) {
            return (<UILobbyError message={translate.failedToConnect} />);
        }
    }
    if (websocket !== AppConstants.STATE_WEBSOCKET_ONLINE) {
        if (!import.meta.env.DEV) {
            return (<UILobbyError message={translate.waitingOnConnection} />);
        }
    }

    // Check if we're kicked
    if (lobby.error === AppConstants.ERR_LOBBY_KICKED) {
        return (<UILobbyError message={lobby.error} />);
    }

    if (lobby.error && lobby.state !== AppConstants.STATE_LOBBY && lobby.state !== AppConstants.STATE_DONE) {
        return (<UILobbyError message={lobby.error} />);
    }

    // If we don't have the lobby code, wait for server to respond to our cookie request (if any)
    if (lobby.code === 0 || lobby.state === AppConstants.STATE_DESYNC) {
        let msg = translate.waitingOnServer;
        if (!sentCookie) msg = translate.noCookie;

        return (<UILobbyError message={msg} />);
    }

    switch (lobby.state) {
        case AppConstants.STATE_LOBBY:
            return (<FullScreenPopup popup={true} isFullScreen={handle.active} onFullScreen={onFullScreen}>
                <FullScreen className="fullscreenOverflow" handle={handle}><LobbyWaiting /></FullScreen>
            </FullScreenPopup>);

        case AppConstants.STATE_STARTING:
            return (<FullScreenPopup popup={false} isFullScreen={handle.active} onFullScreen={onFullScreen}>
                <FullScreen className="fullscreenOverflow" handle={handle}><LobbyStarting /></FullScreen>
            </FullScreenPopup>);

        case AppConstants.STATE_QUESTION:
            return (<FullScreenPopup popup={false} isFullScreen={handle.active} onFullScreen={onFullScreen}>
                <FullScreen className="fullscreenOverflow" handle={handle}><LobbyQuestion /></FullScreen>
            </FullScreenPopup>);

        case AppConstants.STATE_DRINK:
            return (<FullScreenPopup popup={false} isFullScreen={handle.active} onFullScreen={onFullScreen}>
                <FullScreen className="fullscreenOverflow" handle={handle}><LobbyDrink /></FullScreen>
            </FullScreenPopup>);

        case AppConstants.STATE_SLOTS:
            return (<FullScreenPopup popup={false} isFullScreen={handle.active} onFullScreen={onFullScreen}>
                <FullScreen className="fullscreenOverflow" handle={handle}><LobbySlot /></FullScreen>
            </FullScreenPopup>);

        case AppConstants.STATE_ADVERTISE:
            return (<FullScreenPopup popup={false} isFullScreen={handle.active} onFullScreen={onFullScreen}>
                <FullScreen className="fullscreenOverflow" handle={handle}><LobbyAdvertise /></FullScreen>
            </FullScreenPopup>);

        case AppConstants.STATE_DONE:
            return (<FullScreenPopup popup={false} isFullScreen={handle.active} onFullScreen={onFullScreen}>
                <FullScreen className="fullscreenOverflow" handle={handle}><LobbyDone /></FullScreen>
            </FullScreenPopup>);

        default:
            return (<UILobbyError message={translate.invalidGameState} />);
    }
}
